import { useEffect } from 'react';

import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip
} from 'chart.js';
import { Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import CompanySpacePieChart from './CompanySpacePieChart';
import CompanyStatusCards from './CompanyStatusCards';
import DashboardLayout from './DashboardLayout ';
import StatusGraph from './StatusGraph';
// Register the necessary scales and elements with Chart.js
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const HrDashboard = () => {
  const navigate = useNavigate(); // Hook for navigation

  useEffect(() => {
    const hash = window.location.hash;
    const urlParams = new URLSearchParams(hash.split('?')[1]);
    const userNameFromUrl = urlParams.get('userName') ? decodeURIComponent(urlParams.get('userName')) : null;
    const userFromLocalStorage = JSON.parse(localStorage.getItem('user'));
    const userNameFromLocalStorage = userFromLocalStorage ? userFromLocalStorage.userName : null;



    if (userNameFromUrl !== null) {
      if (userNameFromUrl === userNameFromLocalStorage) {
      } else {
        navigate('/');
      }
    } else {
      if (userFromLocalStorage) {
      
      } else {
        navigate('/');
      }
    }
  }, [navigate]); 

  return (
    <DashboardLayout>
      <div className="main-content">
        <Col md={4}>
          <h2 className='text-start' style={{ paddingLeft: '12px' }}>Dashboard</h2>
        </Col>
        <Row >
          <CompanyStatusCards />
        </Row>
        <Row>
          <Col md='6'>
            <StatusGraph />
          </Col>
          <Col md={6} className='text-center'>
            <CompanySpacePieChart />
          </Col>
        </Row>
        {/* <Row>
          <Col md={8}>
            <StatusGraph />
          </Col>
          <Col md={4}>
            <CompanySpacePieChart />
          </Col>
        </Row> */}
      </div>

    </DashboardLayout>
  );
};

export default HrDashboard;
